import * as React from "react";
const SvgCheckboxChecked = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="#826846"
      d="M1 6.818A5.82 5.82 0 0 1 6.818 1h4.364A5.82 5.82 0 0 1 17 6.818v4.364A5.82 5.82 0 0 1 11.182 17H6.818A5.82 5.82 0 0 1 1 11.182z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M5.03 8.93a.473.473 0 0 1 .668 0l2.188 2.189 4.347-4.25a.473.473 0 1 1 .66.677l-4.68 4.575a.473.473 0 0 1-.665-.003L5.03 9.599a.473.473 0 0 1 0-.669"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckboxChecked;
